export default __webpack_public_path__ + "static/media/Sprint@2x.1ea234e7.png";